<template>
    <CompassDialog
        :visible.sync="showModal"
        :title="$t.__('preferences.Dunning.StepForm.add_dunning')"
        class="step-form"
        @closed="handleClose"
    >
        <template slot="default">
            <div class="dialog__default">
                <section>
                    <h3 class="mb-4">{{ $l10n.__('Paramètres de votre relance automatique') }}</h3>

                    <el-form
                        ref="stepForm"
                        labelPosition="top"
                        :model="step"
                        :inlineMessage="true"
                        :inline="false"
                        labelWidth="120px"
                    >
                        <h4>{{ $l10n.__('Titre de votre relance') }}</h4>
                        <el-form-item prop="name" :error="errors.get('name')">
                            <el-input v-model="step.name" :value="step.name" />
                        </el-form-item>

                        <h4>{{ $l10n.__("Délai d'envoi") }}</h4>
                        <el-form-item
                            :label="
                                $t.__(
                                    'preferences.Dunning.StepForm.define_day_number_before_due_date',
                                )
                            "
                            prop="days"
                            :error="errors.get('days')"
                        >
                            <el-select v-model="step.days" class="custom-width-select">
                                <el-option
                                    v-for="daysSelect in daysList"
                                    :key="daysSelect.numberOfDay"
                                    :label="daysSelect.label"
                                    :value="daysSelect.numberOfDay"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <h3>{{ $l10n.__('Paramètres de l’email') }}</h3>

                        <!-- Sender -->
                        <h4>{{ $l10n.__("Expéditeur de l'email") }}</h4>
                        <el-form-item
                            :label="
                                $t.__('preferences.Dunning.StepForm.define_staff_sending_email')
                            "
                            prop="senderType"
                            :error="errors.get('sender_type')"
                        >
                            <el-select v-model="step.senderType" style="width: 300px">
                                <el-option
                                    v-for="sender in senderTypeList"
                                    :key="sender.code"
                                    :label="sender.label"
                                    :value="sender.code"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item
                            v-if="step.senderType == 'staff'"
                            :label="
                                $t.__('preferences.Dunning.StepForm.select_staff_sending_email')
                            "
                            prop="senderId"
                            :error="errors.get('sender_id')"
                        >
                            <el-select
                                v-model="step.senderId"
                                style="width: 300px"
                                filterable
                                remote
                                reserveKeyword
                                :remoteMethod="autoCompleteStaff"
                                :loading="loading"
                            >
                                <el-option
                                    v-for="email in staff"
                                    :key="email.id"
                                    :label="email.label"
                                    :value="email.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <!-- Recipient -->
                        <h4>{{ $l10n.__("Destinataire de l'email") }}</h4>
                        <el-form-item
                            :label="
                                $t.__('preferences.Dunning.StepForm.determine_recipient_contact')
                            "
                            prop="recipientType"
                            :error="errors.get('recipient_type')"
                        >
                            <el-select v-model="step.recipientType" style="width: 300px">
                                <el-option
                                    v-for="recipient in recipientTypeList"
                                    :key="recipient.code"
                                    :label="recipient.label"
                                    :value="recipient.code"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item
                            v-if="step.recipientType == 'staff'"
                            prop="recipientId"
                            :error="errors.get('recipient_id')"
                        >
                            <el-select
                                v-model="step.recipientId"
                                style="width: 300px"
                                filterable
                                remote
                                reserveKeyword
                                :remoteMethod="autoCompleteStaff"
                                :loading="loading"
                            >
                                <el-option
                                    v-for="email in staff"
                                    :key="email.id"
                                    :label="email.label"
                                    :value="email.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <h4>{{ $l10n.__('Email envoyé') }}</h4>
                        <el-form-item
                            :label="
                                $t.__(
                                    'preferences.Dunning.StepForm.choose_email_send_during_reminber',
                                )
                            "
                            prop="emailTemplateId"
                            :error="errors.get('email_templates_custom_id')"
                        >
                            <el-select v-model="step.emailTemplateId" style="width: 300px">
                                <el-option
                                    v-for="emailSelect in emailTemplate"
                                    :key="emailSelect.id"
                                    :label="emailSelect.name"
                                    :value="emailSelect.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>

                    <div class="mt-4 mb-5">
                        <p class="m-0">
                            {{ $l10n.__("Visualisation de l'email") }}
                        </p>
                        <custom-mail-preview :id="step.emailTemplateId" />
                    </div>
                </section>
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="handleClose"
                />
                <CompassButton
                    :label="$t.__('preferences.Dunning.StepForm.reset_values')"
                    type="secondary"
                    class="ml-3"
                    @click="reset()"
                />
                <CompassButton :label="$t.__('common.actions.save')" class="ml-3" @click="save()" />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import CustomMailPreview from 'vcomponents/utilities/CustomMailPreview.vue';
import FormMixins from '../../../mixins/FormMixins';
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapGetters, mapActions, mapMutations } = createNamespacedHelpers('dunning');

export default {
    components: {
        CustomMailPreview,
    },
    mixins: [FormMixins],
    props: {
        visible: {
            required: true,
            type: Boolean,
        },
        planId: {
            required: true,
            type: Number,
        },
        init: {
            required: true,
            type: Object,
        },
        recipientTypeList: {
            required: true,
            type: Array,
        },
    },
    data() {
        return {
            showModal: this.visible,
            step: {},
            loading: false,
            staffs: [],
            senderTypeList: [
                {
                    code: 'doc_owner',
                    label: this.$l10n.__('Le propriétaire du document'),
                },
                {
                    code: 'doc_speaker',
                    label: this.$l10n.__('Le référent interne du document'),
                },
                {
                    code: 'staff',
                    label: this.$l10n.__('Un collaborateur interne'),
                },
            ],
        };
    },
    computed: {
        daysList() {
            return this.getAvailableDays(this.planId, this.step.id).map((numberOfDay) => {
                return {
                    numberOfDay: numberOfDay,
                    label: this.$l10n.n__(
                        '%d jour',
                        '%d jours',
                        Math.abs(numberOfDay),
                        numberOfDay,
                    ),
                };
            });
        },

        ...mapState(['emailTemplate', 'staff']),

        ...mapGetters(['getAvailableDays']),
    },
    created() {
        this.reset();
        if (this.step.senderType === 'staff') {
            this.getStaff(this.step.senderId);
        }
        if (this.step.recipientType === 'staff') {
            this.getStaff(this.step.recipientId).then(this.setStaff([]));
        }
    },
    methods: {
        reset() {
            this.step = {
                id: this.init.id,
                name: this.init.name,
                days: this.init.days,
                emailTemplateId: this.init.email_templates_custom_id,
                senderType: this.init.sender_type,
                senderId: this.init.sender_id,
                recipientType: this.init.recipient_type,
                recipientId: this.init.recipient_id,
            };
        },
        handleClose() {
            this.$emit('update:visible', false);
        },
        save() {
            const update = this.step.id;
            const payload = {
                planId: this.planId,
                step: {
                    id: this.step.id,
                    name: this.step.name,
                    days: this.step.days,
                    email_templates_custom_id: this.step.emailTemplateId,
                    sender_type: this.step.senderType,
                    sender_id: this.step.senderId,
                    recipient_type: this.step.recipientType,
                    recipient_id: this.step.recipientId,
                },
            };

            //for back validator
            if (payload.step.sender_type !== 'staff') {
                payload.step.sender_id = 0;
            }
            if (payload.step.recipient_type !== 'staff') {
                payload.step.recipient_id = 0;
            }

            if (update) {
                this.$store
                    .dispatch('dunning/updateStep', payload)
                    .then(() => {
                        Push.success(this.$l10n.__('La relance a bien été mise à jour'));
                        this.handleClose();
                    })
                    .catch((errors) => {
                        Push.error(this.$l10n.__("Impossible d'enregistrer cette relance"));
                        this.errors.setErrors(errors.response.data.error.message);
                    });
            } else {
                this.$store
                    .dispatch('dunning/createStep', payload)
                    .then(() => {
                        Push.success(this.$l10n.__('La relance a bien été créée'));
                        this.handleClose();
                    })
                    .catch((errors) => {
                        Push.error(this.$l10n.__('Impossible de créer cette relance'));
                        this.errors.setErrors(errors.response.data.error.message);
                    });
            }
        },
        ...mapActions(['autoCompleteStaff', 'getStaff']),
        ...mapMutations(['setStaff']),
    },
};
</script>

<style lang="scss" scoped>
.step-form {
    .dialog {
        &__default {
            padding-bottom: 0px;

            h3 {
                margin: 0;
            }

            .custom-width-select {
                width: 120px;
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}
</style>
